"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextSchema = void 0;
exports.TextSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/text.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "Text",
    "description": "A text attribute",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:text"
            ]
        },
        "markup": {
            "type": "array",
            "items": {
                "type": "string",
                "enum": [
                    "emphasized"
                ]
            }
        },
        "text": {
            "type": "string"
        }
    },
    "required": [
        "text",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGV4dC5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbW9kdWxlcy9hdHRyaWJ1dGVzL3RleHQuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsVUFBVSxHQUFHO0lBQ3hCLEtBQUssRUFBRSw2REFBNkQ7SUFDcEUsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsTUFBTTtJQUNmLGFBQWEsRUFBRSxrQkFBa0I7SUFDakMsTUFBTSxFQUFFLFFBQVE7SUFDaEIsc0JBQXNCLEVBQUUsS0FBSztJQUM3QixZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04saUJBQWlCO2FBQ2xCO1NBQ0Y7UUFDRCxRQUFRLEVBQUU7WUFDUixNQUFNLEVBQUUsT0FBTztZQUNmLE9BQU8sRUFBRTtnQkFDUCxNQUFNLEVBQUUsUUFBUTtnQkFDaEIsTUFBTSxFQUFFO29CQUNOLFlBQVk7aUJBQ2I7YUFDRjtTQUNGO1FBQ0QsTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLFFBQVE7U0FDakI7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLE1BQU07UUFDTixNQUFNO0tBQ1A7Q0FDRixDQUFBIn0=